import {
  assign, endpoint, options, check, convert,
} from '../helpers';
import { Table as action } from '../../redux/actions';

/**
 * Returns all **column** information by **table** name stored in the database
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const column = (properties) => {
  const props = assign(properties);
  const model = {
    Table: props.data.table,
  };

  fetch(endpoint('/table-list-detail'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        if (props.dispatch) {
          props.dispatch(action.setColumn({
            Table: model.Table,
            Columns: response.Data,
          }));
        }
        props.success(response.Data);
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default column;
